import router from '../router'

//vuex mutations
export default {
    loginSuccess(state, user) {
      state.loggedIn = true;
      state.user = user;
    },loginFailure(state) {
        state.loggedIn = false;
        state.user = null;
      },
      logout(state) {
        state.loggedIn = false;
        state.user = null;
        localStorage.clear();
        sessionStorage.clear();
        router.replace('/')
      },
      refreshToken(state, accessToken) {
        state.loggedIn = true;
        state.token = accessToken.access_token;
      }
}